var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.checkIsDetai)?_c('vxe-checkbox',_vm._g(_vm._b({},'vxe-checkbox',_vm.$attrs,false),_vm.$listeners)):_c('span',[_vm._v(_vm._s(_vm.formVal)+" ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-010f46be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/checkbox.vue
// module id = 322
// module chunks = 0 19